<template>
  <div class="internal-gateway-content">
    <div class="program-content">
      <div class="program-content-header">
        {{ $t('page_dnc_source_storage_operation') }}
        <a-button
          :disabled="!canTransmission"
          style="margin-left: 8px;border-radius: 2px;"
          class="program-bottom"
          @click="downloadInternal"
        >
          {{ $t('page_dnc_source_to_internal_storage') }}<a-icon type="arrow-down" />
        </a-button>
        <!-- <a-button disabled style="margin-left: 8px;border-radius: 2px;">
          上传至当前选择路径<a-icon type="arrow-up" />
        </a-button> -->
      </div>
      <div :class="canTransmission ? 'program-content-box' : 'program-content-box program-content-box-disabled'" v-if="sendMachine === 'a'">
        <template v-if="!canTransmission">
          <div class="program-content-box-dis-header">
            <a-icon type="exception" style="font-size: 22px;margin-right: 4px" />
            {{ $t('page_dnc_source_current_filetype_does') }}
          </div>
        </template>
        <template v-else>
          <div
            id="onDrop-header"
            class="program-content-box-header"
            v-dropbale="(meta) => onDrop(meta)"
            @dragenter="(e) => hightLight(e, 'onDrop-header', true)"
            @dragleave="(e) => hightLight(e, 'onDrop-header', false)"
            @drop="(e) => hightLight(e, 'onDrop-header', false)"
          >
            <div>
              <a-icon type="container" style="font-size: 22px;margin-right: 4px" />
              {{ $t('page_dnc_station_file_internal_storage') }}
            </div>
            <div class="header-tip">
              <div>
                {{ $t('page_dnc_source_the_button_above') }}
              </div>
              <div class="program-tip-type">{{ $t('page_dnc_source_supporting_file') }}</div>
            </div>
          </div>
        </template>
        <div id="program-content-box-list" class="program-content-box-list">
          <template v-if="fileType === 'list'">
            <source-table 
              :columns="columns"
              :dataSource="dataSource"
              @clickFile="(value) => clickFile(value)"
              @dblclickFile="(value) => dblclickFile(value)"
            >
            </source-table>
          </template>
          <template v-else>
            <template v-for="(item, index) in dataSource">
              <file
                :key="index"
                :file="item"
                :selectedRowKeys="selectedRowKeys"
                @check="(value) => check(value)"
                @clickFile="(value) => clickFile(value)"
                @dblclickFile="(value) => dblclickFile(value)"
              ></file>
            </template>
          </template>
        </div>
      </div>
      <template v-else>
        <template v-if="!canTransmission">
          <div class="program-content-dis-box">
            <a-icon type="exception" style="font-size: 42px;margin-bottom: 19px" />
            {{ $t('page_dnc_source_current_filetype_does') }}
          </div>
        </template>
        <div
          id="onDrop-body"
          class="program-content-noD-box"
          v-dropbale="(meta) => onDrop(meta)"
          @dragenter="(e) => hightLight(e, 'onDrop-body', true)"
          @dragleave="(e) => hightLight(e, 'onDrop-body', false)"
          @drop="(e) => hightLight(e, 'onDrop-body', false)"
          v-else
        >
          <a-icon type="container" style="font-size: 42px;margin-bottom: 19px" />
          {{ $t('page_dnc_station_file_internal_storage') }}
          <div class="noD-box-header-tip">
            <div>
              {{ $t('page_dnc_source_the_button_above') }}
            </div>
            <div class="program-tip-type">{{ $t('page_dnc_source_supporting_file') }}</div>
          </div>
        </div>
      </template>
    </div>
    <!-- <div class="documents-content">
      <div class="documents-content-header">
        网关存储操作
        <a-button style="margin-left: 8px;border-radius: 2px;" class="documents-bottom">
          下载至网关存储<a-icon type="arrow-down" />
        </a-button>
        <a-button disabled style="margin-left: 8px;border-radius: 2px;">
          上传至当前选择路径<a-icon type="arrow-up" />
        </a-button>
      </div>
      <div class="documents-content-box" v-if="dataSource.length">
        <div class="documents-content-box-header">
          <div><a-icon type="apartment" style="margin-right: 4px" />网关存储</div>
          <div class="header-tip">
            <div>
              点击上方按键或将文件拖拽到这里下载
            </div>
            <div class="documents-tip-type">支持文件类型：加工程序，工艺文件</div>
          </div>
        </div>
        <div id="documents-content-box-list" class="documents-content-box-list">
          <template v-if="fileType === 'list'">
            <source-table :columns="columns" :dataSource="dataSource"></source-table>
          </template>
          <template v-else>
            <file></file>
          </template>
        </div>
      </div>
      <div class="documents-content-noD-box" v-else>
        <a-icon type="apartment" style="font-size: 42px;margin-bottom: 19px" />网关存储
        <div class="noD-box-header-tip">
          <div>
            点击上方按键或将文件拖拽到这里下载
          </div>
          <div class="program-tip-type">支持文件类型：加工程序，工艺文件</div>
        </div>
      </div>
    </div> -->
    <cnc-modal
      :visible="cncVisible"
      :name="cncName"
      :content="cncContent"
      @close="closeCncPreview"
    ></cnc-modal>
  </div>
</template>

<script>
import SourceTable from '../FileList/SourceTable.vue'
import CncModal from '../../../components/CncModal.vue'
import File from '../FileList/File.vue'
import { DncApiServiceProxy } from '@/service-proxies/app-v2/dnc.service-proxies'
const dasp = new DncApiServiceProxy()
export default {
  components: {
    SourceTable,
    CncModal,
    File
  },
  data() {
    return {
      columns: [
        {
          title: this.$t('page_my_document_filenm'),
          dataIndex: 'name',
          ellipsis: true,
          scopedSlots: { customRender: 'name' }
        },
        {
          title: this.$t('page_my_document_size'),
          dataIndex: 'contentLength',
          width: 88,
          ellipsis: true,
          scopedSlots: { customRender: 'contentLength' }
        },
        {
          title: this.$t('page_my_document_type'),
          dataIndex: 'fileType',
          key: 'fileType',
          customRender: (text) => {
            return text == 1
              ? this.$t('page_my_document_program')
              : this.$t('page_my_document_process')
          }
        }
      ],
      dataSource: [],
      selectedRowKeys: [],
      cncVisible: false,
      cncContent: '',
      cncName: ''
    }
  },
  props: {
    sendMachine: {
      // a 单选; b 多选
      type: String,
      default: 'a'
    },
    fileType: {
      type: String,
      default: 'file'
    },
    selectedKey: {
      // 选择树节点
      type: String,
      default: ''
    },
    treeInfo: {
      type: Object,
      default: () => ({})
    },
    canTransmission: {
      type: Boolean,
      default: true
    },
    bottomUplod: {
      type: Number,
      default: 0
    }
  },
  watch: {
    selectedKey: {
      handler() {
        if (this.selectedKey.length) this.getData()
      },
      immediate: true,
      deep: true
    },
    bottomUplod: {
      handler() {
        if (this.selectedKey.length) this.getData()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    dblclickFile(record) {
      this.cncName = record.name
      dasp
        .readCncFile(this.treeInfo.appCode, record.name, this.treeInfo.gateWayCode)
        .then((res) => {
          this.cncContent = res
          this.cncVisible = true
        })
    },
    closeCncPreview() {
      this.cncName = ''
      this.cncContent = ''
      this.cncVisible = false
    },
    check(file) {
      if (this.selectedRowKeys.indexOf(file.id) === -1) {
        this.selectedRowKeys.push(file.id)
      } else {
        const rowKeys = this.selectedRowKeys
        console.log(rowKeys)
        this.selectedRowKeys = rowKeys.filter((res) => res.indexOf(file.id) === -1)
      }
    },
    clickFile(file) {
      this.selectedRowKeys = [file.id]
    },
    downloadInternal() {
      this.$emit('downloadInternal')
    },
    async getData() {
      if (!this.treeInfo.appCode || !this.treeInfo.gateWayCode) {
        return
      }
      this.dataSource = []
      dasp.readCncFileList(this.treeInfo.appCode, this.treeInfo.gateWayCode).then((res) => {
        const data = res ? JSON.parse(res) : null
        if (data && data.fileList) {
          this.dataSource = data.fileList.map((res, index) => {
            const value = {
              id: index + '',
              fileType: res.type,
              name: res.name,
              contentLength: res.size
            }
            return value
          })
        }
      })
    },
    hightLight(e, id, status) {
      e.preventDefault()
      const target = document.getElementById(id)
      target.style.border = status ? '1px solid #4a90e2' : '1px dashed #4a90e2'
    },
    async onDrop(meta) {
      if (typeof meta === 'string' || !meta) {
        return
      }
      this.$emit('downloadInternal')
    }
  }
}
</script>

<style lang="less" scoped>
.internal-gateway-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 8px;
  height: 100%;
  width: 100%;
  .program-content {
    // width: calc(50% - 4px);
    width: 100%;
    height: 100%;
    border-radius: 2px;
    &-header {
      font-size: 14px;
      color: #4a90e2;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-bottom: 8px;
      .program-bottom {
        background-color: #4a90e2;
        color: #fff;
      }
      .program-bottom:disabled {
        color: rgba(0, 0, 0, 0.25);
        background-color: #f5f5f5;
      }
    }
    &-box {
      background-color: #f8f8f8;
      border: dashed 1px #4a90e2;
      height: calc(100% - 40px);
      &-dis-header {
        background-color: #f5f5f5;
        border-bottom: dashed 1px #d6d5d5;
        padding: 8px 16px;
        height: 61px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: rgba(0, 0, 0, 0.25);
      }
      &-header {
        padding: 8px 16px;
        font-size: 16px;
        letter-spacing: 0px;
        background-color: #e6f7ff;
        color: #4a90e2;
        border-bottom: 1px dashed #4a90e2;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .header-tip {
          font-size: 12px;
          line-height: 22px;
          color: rgba(0, 0, 0, 0.85);
          .program-tip-type {
            color: #4a90e2;
          }
        }
      }
      &-list {
        padding: 8px;
        height: calc(100% - 61px);
        overflow-y: auto;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-content: flex-start;
        justify-content: flex-start;
      }
    }
    &-box-disabled {
      border: dashed 1px #d6d5d5;
    }
    &-noD-box {
      background-color: #e6f7ff;
      border: dashed 1px #4a90e2;
      height: calc(100% - 40px);
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      color: #4a90e2;
      .noD-box-header-tip {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        padding-top: 24px;
        .program-tip-type {
          color: rgba(0, 0, 0, 0.45);
        }
      }
    }
    &-dis-box {
      background-color: #f5f5f5;
      border-radius: 2px;
      border: dashed 1px #d8d8d8;
      height: calc(100% - 40px);
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      color: rgba(0, 0, 0, 0.25);
    }
  }

  .documents-content {
    width: calc(50% - 4px);
    height: 100%;
    border-radius: 2px;
    &-header {
      font-size: 14px;
      color: #13c2c2;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-bottom: 8px;
      .documents-bottom {
        background-color: #13c2c2;
        color: #fff;
      }
    }
    &-box {
      background-color: #f8f8f8;
      border: dashed 1px #13c2c2;
      height: calc(100% - 40px);
      &-header {
        padding: 8px 16px;
        font-size: 16px;
        letter-spacing: 0px;
        background-color: #e6fffb;
        color: #13c2c2;
        border-bottom: 1px dashed #13c2c2;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .header-tip {
          font-size: 12px;
          line-height: 22px;
          color: rgba(0, 0, 0, 0.85);
          .documents-tip-type {
            color: #13c2c2;
          }
        }
      }
      &-list {
        padding: 8px;
      }
    }
    &-noD-box {
      background-color: #e6fffb;
      border: dashed 1px #13c2c2;
      height: calc(100% - 40px);
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      color: #13c2c2;
      .noD-box-header-tip {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        padding-top: 24px;
        .program-tip-type {
          color: rgba(0, 0, 0, 0.45);
        }
      }
    }
  }
}
</style>
